module.exports = __webpack_public_path__ + "img/FERCAM_ICONE_DIVISIONALI_RGB-12.a4a730de.png";